import {EtsyListing} from '@coolcolduk/etsy';
import {Image} from '@coolcolduk/ui-image';
import InfoIcon from '@mui/icons-material/Info';
import {Button, Grid, IconButton, TextField, Tooltip, Typography} from '@mui/material';
import dayjs from 'dayjs';
import {useState} from 'react';
import {UserAccount} from '../../../__generated__/resolvers-types';
import {getFirebaseFunction} from '../../../setup/firebase';
import {generateEtsySeoPrompt} from '../../../util/etsy/generateEtsySeoPrompt';

export interface EtsyUpdateListingSeoItemEditorHeaderProps {
  listing: EtsyListing;
  user: UserAccount | null | undefined;
}

export default function EtsyUpdateListingSeoItemEditorHeader({
  listing,
  user,
}: EtsyUpdateListingSeoItemEditorHeaderProps) {
  const image = listing.images?.[0];
  const [keywords, setKeywords] = useState('');
  const [imageExpand, setImageExpand] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleGeneratePrompt = () => {
    navigator.clipboard.writeText(generateEtsySeoPrompt(keywords));
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid container direction="row" spacing={1} alignItems="center">
        <Grid onClick={() => setImageExpand(!imageExpand)}>
          {image && (
            <Image
              src={`${getFirebaseFunction('etsy')}/fetchFile?url=${image.url_fullxfull}`}
              width={imageExpand ? '100%' : 100}
              height={imageExpand ? '100%' : 100}
            />
          )}
        </Grid>
        <Grid>
          <Tooltip
            title={
              <>
                <Typography>ID: {listing.listing_id}</Typography>
                <Typography>
                  Last modified: {dayjs(listing.last_modified_timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')}
                </Typography>
                <Typography>Views: {listing.views}</Typography>
              </>
            }
            onClick={() => {
              setShowTooltip(!showTooltip);
              setTimeout(() => {
                // this timeout uses the value before change
                if (!showTooltip) setShowTooltip(false);
              }, 5000);
            }}
            open={showTooltip}
          >
            <IconButton size="small">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Grid>

        {user && user.permissions.includes('owner') && (
          <>
            <Grid>
              <TextField
                size="small"
                placeholder="Enter keywords"
                sx={{minWidth: 200}}
                multiline
                minRows={3}
                value={keywords}
                onChange={(e) => setKeywords(e.target.value)}
              />
            </Grid>
            <Grid>
              <Button variant="contained" size="small" onClick={handleGeneratePrompt}>
                Prompt to Clipboard
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
}
